import { Alert, styled } from '@mui/material';

export const TelephoneAlert = styled(Alert)({
    position: 'absolute',
    top: '-50px',
    fontFamily: 'Cabin Sketch, arial, serif',
    minWidth: '75px',
});